export default __webpack_public_path__ + "static/media/down-1.134cc6af.svg";